export default { 'Content-Type': 'application/json', Accept: 'application/json' };
